import { Search, Upload } from 'lucide-react';
import { Button, SegmentedControl } from '@/shared/components';
import { AkteBreadcrumb } from './AkteBreadcrumb';
import type { AkteViewMode } from './useAkteBrowser';

interface Props {
  path: string;
  search: string;
  viewMode: AkteViewMode;
  onNavigate: (path: string) => void;
  onSearch: (q: string) => void;
  onViewMode: (mode: AkteViewMode) => void;
  onUploadHere: () => void;
}

/**
 * Breadcrumb + Suche + Ansicht-Toggle + „Hierher hochladen" über der Content-Zone.
 *
 * Bewusst gestapelt und umbrechend statt einer Zeile mit Viewport-Breakpoint: die Breite dieser
 * Zone hängt nicht am Fenster, sondern daran, ob die Detail-Pane offen ist. Mit
 * Viewport-Breakpoints stand auf 1440 px mit offener Pane ein auf „A" gestauchter Breadcrumb
 * neben einem abgeschnittenen Ansichtsumschalter (§9 — Mobile ist eine eigene Komposition, und
 * eine schmale Spalte ist derselbe Fall).
 */
export function AkteBrowserToolbar({
  path,
  search,
  viewMode,
  onNavigate,
  onSearch,
  onViewMode,
  onUploadHere,
}: Props) {
  return (
    <div className="mb-4 space-y-3">
      <AkteBreadcrumb path={path} onNavigate={onNavigate} />
      <div className="flex flex-wrap items-center gap-2">
        <div className="relative w-full sm:w-56">
          <Search
            size={15}
            className="text-ink-faint pointer-events-none absolute left-3 top-1/2 -translate-y-1/2"
          />
          <input
            type="search"
            value={search}
            onChange={(e) => onSearch(e.target.value)}
            placeholder="In diesem Ordner suchen…"
            aria-label="In diesem Ordner suchen"
            className="border-line bg-card text-ink placeholder:text-ink-faint focus:border-sealwax min-h-11 w-full rounded-full border py-2 pl-9 pr-3 text-sm outline-none transition-colors"
          />
        </div>
        <SegmentedControl
          value={viewMode}
          onChange={onViewMode}
          options={[
            { value: 'list', label: 'Liste' },
            { value: 'tiles', label: 'Kacheln' },
          ]}
        />
        <Button variant="ghost" leftIcon={<Upload size={14} />} onClick={onUploadHere}>
          Hierher hochladen
        </Button>
      </div>
    </div>
  );
}
